import { apiAction, apiFetch, getMetaContent } from 'utils';
import DuckEntity from './DuckEntity';

const duck = new DuckEntity('sharedPortalConfigs');

const update = (sharedPortalConfig, logoFile) => {
  const token = getMetaContent('csrf-token');

  const headers = { Accept: 'application/json', 'X-CSRF-Token': token };
  const data = new FormData();
  data.append('shared_portal_config', JSON.stringify(sharedPortalConfig));
  if (logoFile) {
    data.append('shared_portal_logo', logoFile);
  }

  const actionParams = { shared_portal_config: sharedPortalConfig, shared_portal_logo: logoFile }
  return apiAction(
    duck.actions.SAVE_BEGIN, duck.actions.SAVE_SUCCESS, duck.actions.SAVE_ERROR,
    (state) => apiFetch.put(state, duck.config.entityApiPath(sharedPortalConfig.id), null, { rawBody: data, headers }),
    actionParams
  );
};

export const sharedPortalConfigs = {
  ...duck,
  actions: {
    ...duck.actions,
    update
  }
};

export default sharedPortalConfigs.reducer;
